import * as React from "react";
import "./endorsement.scss";
import { formatRut } from "../../helperComponents/InputRut/rutValidate";
import * as moment from "moment";
import { fullName } from "../../helperComponents";

var ListEndorsement = function ListEndorsement(props) {
  var endorsements = props.endorsements;

  var renderStatusLabel = function renderStatusLabel(endorsement) {
    switch (endorsement.status_name) {
      case "Pendiente":
        return /*#__PURE__*/React.createElement("span", {
          className: "label label-default"
        }, endorsement.status_name);

      case "Aprobado":
        return /*#__PURE__*/React.createElement("span", {
          className: "label label-success"
        }, endorsement.status_name);

      case "Rechazado":
        return /*#__PURE__*/React.createElement("span", {
          className: "label label-danger"
        }, endorsement.status_name);
    }
  };

  if (endorsements && endorsements.length > 0) {
    return /*#__PURE__*/React.createElement("table", {
      className: "table table-striped table-sm table-bordered col-md-10 cntListEndorsement",
      "data-toggle": "table"
    }, /*#__PURE__*/React.createElement("thead", {
      className: "tableHeader"
    }, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", {
      scope: "col"
    }, "N\xBA Solicitud Endoso"), /*#__PURE__*/React.createElement("th", {
      scope: "col"
    }, "N\xBA Endoso Compa\xF1ia"), /*#__PURE__*/React.createElement("th", {
      scope: "col"
    }, "N\xBA P\xF3liza"), /*#__PURE__*/React.createElement("th", {
      scope: "col"
    }, "Contratante"), /*#__PURE__*/React.createElement("th", {
      scope: "col"
    }, "Asegurado"), /*#__PURE__*/React.createElement("th", {
      scope: "col"
    }, "Estado Endoso"), /*#__PURE__*/React.createElement("th", {
      scope: "col"
    }, "Tipo Endoso"), /*#__PURE__*/React.createElement("th", {
      scope: "col"
    }, "Creado por"), /*#__PURE__*/React.createElement("th", {
      scope: "col"
    }, "Fecha Creaci\xF3n"), /*#__PURE__*/React.createElement("th", {
      scope: "col"
    }, "Fecha Inicio Vigencia"))), /*#__PURE__*/React.createElement("tbody", {
      className: "tableBody"
    }, endorsements && endorsements.map(function (endorsement) {
      return /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, endorsement.id ? endorsement.id : "-"), /*#__PURE__*/React.createElement("td", null, "(no existe todav\xEDa)"), /*#__PURE__*/React.createElement("td", null, endorsement.poliza.code ? endorsement.poliza.code : "-"), /*#__PURE__*/React.createElement("td", null, endorsement.contratante ? "".concat(fullName(endorsement.contratante), " ").concat(formatRut(endorsement.contratante.rut || "")) : "-"), /*#__PURE__*/React.createElement("td", null, endorsement.asegurado ? "".concat(fullName(endorsement.asegurado), " ").concat(formatRut(endorsement.asegurado.rut || "")) : "-"), /*#__PURE__*/React.createElement("td", null, renderStatusLabel(endorsement)), /*#__PURE__*/React.createElement("td", null, endorsement.endorsement_type ? endorsement.endorsement_type : "-"), /*#__PURE__*/React.createElement("td", null, endorsement.created_by_email ? endorsement.created_by_email : "-"), /*#__PURE__*/React.createElement("td", null, endorsement.created_at ? moment(endorsement.created_at).format("DD-MM-YYYY") : "-"), /*#__PURE__*/React.createElement("td", null, endorsement.start_date ? moment(endorsement.start_date).format("DD-MM-YYYY") : "-"));
    })));
  }

  ;
  return /*#__PURE__*/React.createElement("h3", null, "No se han encontrado Endosos.");
};

export default ListEndorsement;